// tslint:disable:max-line-length
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { TranslationService } from '../services/translation.service';
import { TranslationConstants } from '../constants/translations.constats';
import { NameValuePair } from '../models/NameValuePair.models';
import { CommonModuleTranslations } from '../translations/common-module.translations';

@Injectable()
export class CommonTranslationResolverService  {
    constructor(
        public translationService: TranslationService
    ) { }

    resolve(route?: ActivatedRouteSnapshot) {
        return this.translationService
            .translateModule(CommonModuleTranslations)
            .then(translations => {
                const temp: Array<NameValuePair> = JSON.parse(localStorage.getItem(TranslationConstants.TRANSLATIONS)) || [];
                localStorage.setItem(TranslationConstants.TRANSLATIONS, JSON.stringify(temp.concat(translations)));
                return;
            });
    }
}
